export default "__VITE_ASSET__CBmeiFnJ__"